var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        [
          _c(
            "el-form",
            { attrs: { "label-position": "top", size: "small" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "numberSearch", attrs: { label: "" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                  },
                                  model: {
                                    value: _vm.type1,
                                    callback: function ($$v) {
                                      _vm.type1 = $$v
                                    },
                                    expression: "type1",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("mdfeTranslate.MDFEKey"),
                                      value: "keys",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "collectionCenter.carNumber"
                                      ),
                                      value: "tags",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("InputTextareaCmp", {
                            ref: "inputTextareaRef",
                            attrs: {
                              val: _vm.listVal,
                              "max-length": 2000,
                              "min-rows": 4,
                            },
                            on: {
                              input: function (_, val) {
                                return (_vm.listVal = val)
                              },
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 18 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 10 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("GlobalSetObj.operationTime"),
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      type: "datetimerange",
                                      "range-separator": "-",
                                      "picker-options": _vm.pickerOptions,
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      "default-time": ["00:00:00", "23:59:59"],
                                      "start-placeholder": _vm.$t(
                                        "GlobalSetObj.startDate"
                                      ),
                                      "end-placeholder": _vm.$t(
                                        "GlobalSetObj.endDate"
                                      ),
                                    },
                                    model: {
                                      value: _vm.invoiceIssueTime,
                                      callback: function ($$v) {
                                        _vm.invoiceIssueTime = $$v
                                      },
                                      expression: "invoiceIssueTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 7 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("collectionCenter.belongD"),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "collectionCenter.pleaseChoose"
                                        ),
                                        clearable: "",
                                        filterable: "",
                                        remote: "",
                                        multiple: "",
                                        "reserve-keyword": "",
                                        "collapse-tags": "",
                                        "remote-method": _vm.getSiteOption,
                                      },
                                      on: {
                                        "visible-change":
                                          _vm.getSiteOptionVisible,
                                      },
                                      model: {
                                        value: _vm.queryForm.params.siteIds,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryForm.params,
                                            "siteIds",
                                            $$v
                                          )
                                        },
                                        expression: "queryForm.params.siteIds",
                                      },
                                    },
                                    _vm._l(_vm.siteAllList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.name,
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 7 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "collectionCenter.operationType"
                                    ),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        clearable: "",
                                        placeholder: _vm.$t(
                                          "GlobalSetObj.pleaseChoose"
                                        ),
                                      },
                                      model: {
                                        value:
                                          _vm.queryForm.params.operationType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryForm.params,
                                            "operationType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryForm.params.operationType",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t(
                                            "mdfeTranslate.SystemAutomatic"
                                          ),
                                          value: 1,
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: _vm.$t(
                                            "mdfeTranslate.UserManual"
                                          ),
                                          value: 2,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      icon: "el-icon-search",
                                      size: "mini",
                                    },
                                    on: { click: _vm.search },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("basicData.Search")) + " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      icon: "el-icon-refresh",
                                      size: "mini",
                                    },
                                    on: { click: _vm.onReset },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("basicData.reset")) + " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value:
                        "btn:invoiceCenter:excludeRepeatedLoadingData_export",
                      expression:
                        "'btn:invoiceCenter:excludeRepeatedLoadingData_export'",
                      arg: "remove",
                    },
                  ],
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.exportData },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.export")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value:
                        "btn:invoiceCenter:excludeRepeatedLoadingData_dataExclusion",
                      expression:
                        "'btn:invoiceCenter:excludeRepeatedLoadingData_dataExclusion'",
                      arg: "remove",
                    },
                  ],
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.openDataExclusion },
                },
                [_vm._v(_vm._s(_vm.$t("mdfeTranslate.DataExclusion")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value:
                        "btn:invoiceCenter:excludeRepeatedLoadingData_validateRepeat",
                      expression:
                        "'btn:invoiceCenter:excludeRepeatedLoadingData_validateRepeat'",
                      arg: "remove",
                    },
                  ],
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.openRepeatRate },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("mdfeTranslate.RepeatRateConfiguration")) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticClass: "table-height",
              attrs: {
                data: _vm.tableData,
                border: "",
                "header-cell-style": { background: "#f2f2f2", color: "black" },
                height: _vm.tableHeightRow.height,
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "55",
                  align: "center",
                  fixed: "left",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.serial"),
                  align: "center",
                  type: "index",
                  width: "80",
                  fixed: "left",
                },
              }),
              _vm._l(_vm.tableHeaderList, function (item) {
                return _c("el-table-column", {
                  key: item.id,
                  attrs: {
                    align: item.center,
                    label: item.label,
                    "min-width": item.minWidth,
                    prop: item.prop,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            item.prop === "vtag"
                              ? _c(
                                  "div",
                                  _vm._l(scope.row.vtag, function (item, ind) {
                                    return _c("div", { key: ind }, [
                                      _vm._v(" " + _vm._s(item) + " "),
                                    ])
                                  }),
                                  0
                                )
                              : item.prop === "bag"
                              ? _c(
                                  "div",
                                  _vm._l(scope.row.bag, function (item, ind) {
                                    return _c("div", { key: ind }, [
                                      _vm._v(" " + _vm._s(item) + " "),
                                    ])
                                  }),
                                  0
                                )
                              : item.prop === "mdfeKey"
                              ? _c(
                                  "div",
                                  _vm._l(
                                    scope.row.mdfeKey,
                                    function (item, ind) {
                                      return _c("div", { key: ind }, [
                                        _vm._v(" " + _vm._s(item) + " "),
                                      ])
                                    }
                                  ),
                                  0
                                )
                              : item.prop === "updateUser"
                              ? _c("div", [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.createUser[scope.row.updateUser]
                                      )
                                    ),
                                  ]),
                                ])
                              : item.prop === "operationType"
                              ? _c("div", [
                                  _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          scope.row.operationType === 1
                                            ? _vm.$t(
                                                "mdfeTranslate.SystemAutomatic"
                                              )
                                            : _vm.$t("mdfeTranslate.UserManual")
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ])
                              : _c("div", [
                                  _vm._v(
                                    " " + _vm._s(scope.row[item.prop]) + " "
                                  ),
                                ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  "current-page": _vm.queryForm.pageNumber,
                  "page-size": _vm.queryForm.pageSize,
                  "page-sizes": [10, 20, 50, 100],
                  total: _vm.total,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("data-exclusion", {
        key: _vm.dataExclusionKey,
        ref: "dataExclusionRef",
        on: { updateTableData: _vm.updateTableData },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("mdfeTranslate.RepeatRateConfiguration"),
            visible: _vm.showRepeatRateWindow,
            width: "500px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showRepeatRateWindow = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "30px" } },
            [
              _c(
                "el-form",
                {
                  ref: "repetitionRateRef",
                  staticStyle: {
                    display: "inline-block",
                    "margin-left": "10px",
                  },
                  attrs: {
                    model: _vm.repetitionRate,
                    "label-position": "top",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("mdfeTranslate.RepeatRateConfiguration"),
                        prop: "repeatRate",
                        rules: {
                          required: true,
                          validator: _vm.validateRepeatRate,
                          trigger: ["blur", "change"],
                        },
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "260px" },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.preventDefault()
                            return _vm.confirmRepeatRate($event)
                          },
                        },
                        model: {
                          value: _vm.repetitionRate.repeatRate,
                          callback: function ($$v) {
                            _vm.$set(_vm.repetitionRate, "repeatRate", $$v)
                          },
                          expression: "repetitionRate.repeatRate",
                        },
                      }),
                      _vm._v(" % "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: { click: _vm.closeRepeatRate },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.cancel")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.confirmRepeatRate },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.confirm")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }